import { render, staticRenderFns } from "./RestedCard.vue?vue&type=template&id=375cacbe&scoped=true&"
import script from "./RestedCard.vue?vue&type=script&lang=js&"
export * from "./RestedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375cacbe",
  null
  
)

export default component.exports